import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const cuisineFunc = () => {
  const sliders = document.querySelectorAll('.js-cuisine-slider');

  // Swiper.jsの起動
  let cnt = 0;
  sliders.forEach(function(slider) {
    cnt++;
    new Swiper(slider, {
      direction: 'horizontal',
      loop: true,
      spaceBetween: 45,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next'+cnt+'',
        prevEl: '.swiper-button-prev'+cnt+'',
      },
      breakpoints: {
        768: {
          spaceBetween: 80,
          slidesPerView: 2,
        },
      },
    });
  });
}
